<script setup>
import { reactive, ref, watch } from 'vue';
import InputRangoFechas from '../cifra/InputRangoFechas.vue';

const props = defineProps({
  condicion: { type: Object, required: true },
});

const emits = defineEmits(['aceptar']);

const condicionInterna = reactive(props.condicion);

const fechaInicio = ref(condicionInterna.config?.fecha_inicio);
const fechaFin = ref(condicionInterna.config?.fecha_fin);

function actualizarFecha(campo, valor) {
  condicionInterna.config = condicionInterna.config || {};
  condicionInterna.config[campo] = valor;
}

watch(fechaInicio, (valor) => {
  actualizarFecha('fecha_inicio', valor);
});

watch(fechaFin, (valor) => {
  actualizarFecha('fecha_fin', valor);
});

function aceptar() {
  emits('aceptar', condicionInterna);
}
</script>

<template>
  <div class="form-group-inline-flex">
    <div>
      {{ $t('rango_fechas') }}
    </div>
    <div>
      <InputRangoFechas
        v-model:fechaInicio="fechaInicio"
        v-model:fechaFin="fechaFin"
        class="form-group"
      />
    </div>
  </div>
  <div class="form-actions m-t">
    <button type="button" class="btn btn-cifra" @click.prevent="aceptar">
      {{ $I18n.t('Aceptar') }}
    </button>
  </div>
</template>
